<template>
    <div class="mapwithpoint">

        <div class="map_center">
            <!-- <div class="tooltip">
                <div class="tip-list">
                    <div class="tip-item">
                        <img src="@/assets/alert/point1_1.png" alt="">
                        <span class="label">正常</span>
                    </div>
                    <div class="tip-item">
                        <img src="@/assets/alert/point2.png" alt="">
                        <span class="label">告警</span>
                    </div>
                    <div class="tip-item">
                        <img src="@/assets/alert/point6.png" alt="">
                        <span class="label">断电</span>
                    </div>
                    <div class="tip-item">
                        <img src="@/assets/alert/point3.png" alt="">
                        <span class="label">停机</span>
                    </div>
                    <div class="tip-item">
                        <img src="@/assets/alert/point5.png" alt="">
                        <span class="label">维护</span>
                    </div>
                    <div class="tip-item">
                        <img src="@/assets/alert/point4.png" alt="">
                        <span class="label">预警</span>
                    </div>
                </div>
            </div> -->
            <div class="border_top">

                <div class="map_box" id="mapBox"></div>
                <!-- <div class="map_footer">
                    <a href="javaScript: void(0);" title="回到原点">
                        <div @click="goMapHome" class="icon_active dingwei">
                            <Icon type="ios-ionic-outline" />
                        </div>
                    </a>
                    <a href="javaScript: void(0);" title="缩放">
                        <div @click="bigSmall" class="icon_active big_small">
                            <Icon type="md-expand" v-if="bigSreeen" />
                            <Icon type="md-contract" v-if="!bigSreeen" />
                        </div>
                    </a>
                    <div class="selectI" style="display: flex" v-show="showIndustries">
                        <SelectZ :data="industriesList" placeholder="选择行业" @change="selectIndustries"></SelectZ>
                    </div>
                    <div class="selectG" style="display: flex" v-show="showGroup">
                        <SelectZ :data="groupList" placeholder="选择区域" @change="selectGroup"></SelectZ>
                    </div>
                    <div class="admin_main" @click="goAdminPage">
                        <Icon type="md-globe" />后台管理
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import iconred from '@/assets/newscreen/point/icon_landmark_r.png'
import iconzired from '@/assets/newscreen/point/icon_landmark_p.png'
import iconorange from '@/assets/newscreen/point/icon_landmark_o.png'
import icongreen from '@/assets/newscreen/point/icon_landmark_g.png'
import iconbrowse from '@/assets/newscreen/point/icon_landmark_b.png'
import icongrey from '@/assets/newscreen/point/icon_landmark_grey.png'

export default {
    data() {
        return {
            // 地图实例
            map: null,
            // 全屏开关
            bigSreeen: true,
            // 全屏方式 true为js操作方式 false为浏览器操作方式(f11、esc)
            bigWayFlag: false,

            //所属环保所分组数据
            groupList: [],
            group_selected: null,
            showGroup: false,

            //所属行业
            industriesList: [],
            Industries_selected: null,
            showIndustries: false,

            // 企业列表
            companyList: [],

            markerList: [],

            siteList: [],
            iconMap: {
                "1": icongreen,
                "2": iconred,
                "4": icongrey,
                "256": iconred,
                "32": iconzired,
                "8": iconorange,
                "16": iconred,
                "128": iconbrowse
            }
        }
    },
    async mounted() {
        this.initMap();
        // let parkInfo = this.$Local.getLocal("park", "object");
        // this.map = new AMap.Map('container', {
        //     viewMode: '2D',  // 默认使用 2D 模式
        //     zoom:16,  //初始化地图层级
        //     center: [parkInfo[0].longitude, parkInfo[0].latitude]  //初始化地图中心点
        // });
    },

    created() {
        // this.getGroupSelected();
        // this.getIndustriesSelected();
    },

    methods: {
        drawMarker(siteList) {
            this.siteList = siteList;
            for (let i = 0; i < this.siteList.length; i++) {
                let siteItem = this.siteList[i];
                // 点标记显示内容，HTML要素字符串
                const markerContent = `
                        <img src="${this.iconMap[siteItem.status + '']}">
                    `
                if (!siteItem.longitude || !siteItem.latitude) continue;
                const position = new AMap.LngLat(siteItem.longitude, siteItem.latitude); // Marker经纬度
                const marker = new AMap.Marker({
                    icon: this.iconMap[siteItem.status + ''],
                    position: position,
                    // content: markerContent, // 将 html 传给 content
                    offset: new AMap.Pixel(-10, -10) // 以 icon 的 [center bottom] 为原点
                });
                marker.on("click", (data) => {
                    // 地图图标点击事件
                    let bindCompanies = this.$Local.getLocal("bindCompanies", "object"); // 获取用户企业信息
                    // 设置数组第一个企业信息标识为uuid(uuid取的是数组第一位)
                    bindCompanies.map((prop, index) => {
                        // 冒泡排序换位置
                        let temp = bindCompanies[0];
                        // if (prop.name == data.name) {
                        //     bindCompanies[0] = bindCompanies[index];
                        //     bindCompanies[index] = temp;
                        // }
                    });
                    // console.log(bindCompanies)
                    // bindCompanies[0] = data;
                    this.$Local.setLocal("bindCompanies", bindCompanies);
                    let roleList = this.$Local.getLocal("role", "object");
                    if (roleList.indexOf("siteDetection:page") != -1) {
                        this.$router.push({
                            // 路由记录页面
                            path: "/chome/siteDetection",
                            query: {
                                siteMn: siteItem.mn,
                                siteId: siteItem.id,
                                date: new Date().getTime(),
                            },
                        });
                    } else {
                        this.$router.push("chome/waste");
                    }
                }); //绑定click事件
                this.map.add(marker);
            }

        },
        showPicHandle() { },

        // 获取企业列表
        getCompanyList(map) {
            this.$api.Deploy.getSiteList(
                {
                    pageCurrent: 1,
                    pageSize: 20,
                    content: ''
                },
                ["uuid", "company"]).then((res)=>{
                    if (res.code == 0) {
                        let data = res.data.list;
                        this.companyList = data;
                        this.markMap(data, map);
                        this.$emit("companyChange", {
                            companyMap: {
                                data: this.companyList,
                                flag: this.changeFlag,
                            },
                        });
                    } else {
                        this.$Notice.warning({
                            title: "获取企业列表失败",
                            desc: res.message || "请联系管理员",
                        });
                    }

                })
            // this.companyList = [
            //     {
            //         "alias": "安徽华谊",
            //         "deviceSets": 0,
            //         "groupId": 0,
            //         "longitude": "119.459137",
            //         "latitude": "29.529264",
            //         "industriesId": 0,
            //         "name": "安徽华谊化工有限公司",
            //         "parkCompany": false,
            //         "parkId": 1,
            //         "setParkManager": false,
            //         "status": 2,
            //         "statusName": "告警",
            //         "uuid": "00a00795-ef81-4e2c-895c-0bdce88d2e52"
            //     },
            //     {
            //         "alias": "辉煌镀业",
            //         "deviceSets": 13,
            //         "groupId": 2,
            //         "longitude": "119.459137",
            //         "latitude": "29.529264",
            //         "industriesId": 0,
            //         "name": "建德市辉煌镀业有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "6a028af7-da4e-4b01-843d-a112e32e8027"
            //     },
            //     {
            //         "alias": "马南镀业",
            //         "deviceSets": 15,
            //         "groupId": 2,
            //         "longitude": "119.459997",
            //         "latitude": "29.529876",
            //         "industriesId": 0,
            //         "name": "建德市马南镀业有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 32,
            //         "statusName": "断电",
            //         "uuid": "11901c78-9d3f-4376-b314-d09711dbbeea"
            //     },
            //     {
            //         "alias": "新盛镀业",
            //         "deviceSets": 18,
            //         "groupId": 2,
            //         "longitude": "119.460033",
            //         "latitude": "29.530696",
            //         "industriesId": 0,
            //         "name": "建德市新盛镀业有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "badaff46-5a4e-4a4b-bc4d-8d3348edb226"
            //     },
            //     {
            //         "alias": "茂元环保",
            //         "deviceSets": 3,
            //         "groupId": 2,
            //         "longitude": "119.468772",
            //         "latitude": "29.519906",
            //         "industriesId": 0,
            //         "name": "杭州茂元环保科技有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "818aea26-ed56-49ca-87ca-5be320983d06"
            //     },
            //     {
            //         "alias": "贝兴环保材料",
            //         "deviceSets": 2,
            //         "groupId": 2,
            //         "longitude": "119.466821",
            //         "latitude": "29.5199",
            //         "industriesId": 0,
            //         "name": "杭州贝兴新型环保材料有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 4,
            //         "statusName": "停机",
            //         "uuid": "8014d9e4-201d-4161-ad5b-391a05b7d6ec"
            //     },
            //     {
            //         "alias": "龙橡实业",
            //         "deviceSets": 4,
            //         "groupId": 0,
            //         "longitude": "119.471957",
            //         "latitude": "29.521013",
            //         "industriesId": 0,
            //         "name": "浙江龙橡实业有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "ec7f32e0-9ea1-47dd-8552-ce9c41520af9"
            //     },
            //     {
            //         "alias": "雄盛科技",
            //         "deviceSets": 3,
            //         "groupId": 2,
            //         "longitude": "119.470862",
            //         "latitude": "29.521168",
            //         "industriesId": 0,
            //         "name": "浙江雄盛科技有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 4,
            //         "statusName": "停机",
            //         "uuid": "8f4ceadf-07ad-44d8-8f4d-57c91b3753ea"
            //     },
            //     {
            //         "alias": "禾太生物",
            //         "deviceSets": 1,
            //         "groupId": 2,
            //         "longitude": "119.470384",
            //         "latitude": "29.523876",
            //         "industriesId": 0,
            //         "name": "杭州禾太生物科技有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 4,
            //         "statusName": "停机",
            //         "uuid": "8967eb09-19d7-47e3-8f29-37ed3808252d"
            //     },
            //     {
            //         "alias": "百汇电气",
            //         "deviceSets": 0,
            //         "groupId": 2,
            //         "longitude": "119.47337",
            //         "latitude": "29.521013",
            //         "industriesId": 0,
            //         "name": "浙江百汇电气有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 4,
            //         "statusName": "停机",
            //         "uuid": "89738321-8078-4b75-ab2f-b54e0d3ee238"
            //     },
            //     {
            //         "alias": "亿洲源新材料",
            //         "deviceSets": 1,
            //         "groupId": 2,
            //         "longitude": "119.470548",
            //         "latitude": "29.520035",
            //         "industriesId": 0,
            //         "name": "浙江亿洲源新材料科技有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "14efd5cd-750e-4559-8fec-87c1ad0e2883"
            //     },
            //     {
            //         "alias": "大宇机械",
            //         "deviceSets": 1,
            //         "groupId": 1,
            //         "longitude": "119.412122",
            //         "latitude": "29.514798",
            //         "industriesId": 0,
            //         "name": "杭州建德大宇机械制造有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 4,
            //         "statusName": "停机",
            //         "uuid": "fc45e4e8-b858-44cf-81bd-b9159c549f5d"
            //     },
            //     {
            //         "alias": "锦恒材料",
            //         "deviceSets": 3,
            //         "groupId": 0,
            //         "longitude": "119.412918",
            //         "latitude": "29.513304",
            //         "industriesId": 0,
            //         "name": "杭州锦恒材料科技有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "eafbe541-a4f6-46d7-8215-cba422fc5726"
            //     },
            //     {
            //         "alias": "东翼新材料",
            //         "deviceSets": 3,
            //         "groupId": 1,
            //         "longitude": "119.414485",
            //         "latitude": "29.52139",
            //         "industriesId": 0,
            //         "name": "浙江东翼新材料有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 2,
            //         "statusName": "告警",
            //         "uuid": "001f2fb1-4ec7-4d34-8dbe-dae0cea3bef9"
            //     },
            //     {
            //         "alias": "德跃园林",
            //         "deviceSets": 3,
            //         "groupId": 1,
            //         "longitude": "119.405895",
            //         "latitude": "29.511743",
            //         "industriesId": 0,
            //         "name": "杭州德跃园林工具有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "58b3c9ea-bf27-4457-9fd2-bd2cb100b2a2"
            //     },
            //     {
            //         "alias": "睿得欧益",
            //         "deviceSets": 7,
            //         "groupId": 1,
            //         "longitude": "119.407741",
            //         "latitude": "29.516451",
            //         "industriesId": 0,
            //         "name": "浙江睿得欧益汽车配件有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "20910965-b411-4e8a-a67f-19567a110021"
            //     },
            //     {
            //         "alias": "坤孚智创",
            //         "deviceSets": 1,
            //         "groupId": 1,
            //         "longitude": "119.410046",
            //         "latitude": "29.519742",
            //         "industriesId": 0,
            //         "name": "浙江坤孚智创科技有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 32,
            //         "statusName": "断电",
            //         "uuid": "3cf824d2-b10c-445f-93c0-71468cfef664"
            //     },
            //     {
            //         "alias": "东大材料",
            //         "deviceSets": 5,
            //         "groupId": 2,
            //         "longitude": "119.460567",
            //         "latitude": "29.531614",
            //         "industriesId": 0,
            //         "name": "浙江东大特种材料有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 1,
            //         "statusName": "正常",
            //         "uuid": "f253b8f5-9183-4415-a201-4e0570f71248"
            //     },
            //     {
            //         "alias": "众新建材",
            //         "deviceSets": 5,
            //         "groupId": 1,
            //         "longitude": "119.414",
            //         "latitude": "29.5115",
            //         "industriesId": 0,
            //         "name": "杭州市众新新型建材有限公司",
            //         "parkCompany": false,
            //         "setParkManager": false,
            //         "status": 32,
            //         "statusName": "断电",
            //         "uuid": "29a5b482-b8cb-4c94-aeb0-1530cbab9cfa"
            //     }
            // ]
            // this.markMap(this.companyList, map);
            // this.$emit("companyChange", {
            //     companyMap: {
            //         data: this.companyList,
            //         flag: this.changeFlag,
            //     },
            // });
            this.$api.A_Company.getCompanyHomeList(null, ["uuids", "park"]).then(
                (res) => {
                    if (res.code == 0) {
                        // res.data = [{
                        //     "alias": "安徽华谊-----",
                        //     "deviceSets": 0,
                        //     "groupId": 0,
                        //     "longitude": "119.459137",
                        //     "latitude": "29.529264",
                        //     "industriesId": 0,
                        //     "name": "安徽华谊化工有限公司",
                        //     "parkCompany": false,
                        //     "parkId": 1,
                        //     "setParkManager": false,
                        //     "status": 2,
                        //     "statusName": "告警",
                        //     "uuid": "00a00795-ef81-4e2c-895c-0bdce88d2e52"
                        // }]
                        let data = res.data;
                        this.companyList = data;
                        this.markMap(data, map);
                        this.$emit("companyChange", {
                            companyMap: {
                                data: this.companyList,
                                flag: this.changeFlag,
                            },
                        });
                    } else {
                        this.$Notice.warning({
                            title: "获取企业列表失败",
                            desc: res.message || "请联系管理员",
                        });
                    }
                }
            );
        },

        initMap() {
            // 地图初始化
            let parkInfo = this.$Local.getLocal("park", "object")[0];
            console.log("parkInfo",parkInfo);
            
            if (parkInfo.name.indexOf("鄞州") !== -1) {
                this.newMap3d(parkInfo);
                setTimeout(() => {
                    this.getCompanyList(this.map);
                }, 1000)
            } else {
                var map = new AMap.Map("mapBox", {
                    // zoom: 17, //级别
                    zoom: parkInfo.imgUrlMpZ, //级别
                    // center: [121.182912, 29.071992], //中心点坐标
                    center: [parkInfo.imgUrlMpX, parkInfo.imgUrlMpY],
                    pitch: 50,
                    // center: [119.164391,29.598999],
                    viewMode: "3D", //使用3D视图
                    mapStyle: "amap://styles/b8073f280832853686c06173f98a21dc",
                    layers: [//使用多个图层
                        new AMap.TileLayer.Satellite(),
                        new AMap.TileLayer.RoadNet()
                    ]
                });
                this.map = map;
                this.getCompanyList(map);
            }


        },
        newMap3d(parkInfo) {
            let name = parkInfo.name;
            var optionMap = {
                tiantai: {
                    name: "天台",
                    value: [121.184712, 29.072394], // 120.950958,29.078577
                    zoom: parkInfo.imgUrlMpZ  //17
                },
                yinzhou: {
                    name: "鄞州",
                    value: [121.686216, 29.695533],
                    zoom: parkInfo.imgUrlMpZ // 11
                }
            }

            var option;
            if (name.indexOf("鄞州") !== -1) {
                option = optionMap["yinzhou"];
            } else if (name.indexOf("天台") !== -1) {
                option = optionMap["tiantai"];
            }


            var opts = {
                subdistrict: 0,
                extensions: 'all',
                level: 'city'
            };
            //利用行政区查询获取边界构建mask路径
            //也可以直接通过经纬度构建mask路径
            var district = new AMap.DistrictSearch(opts);
            district.search(option.name, (status, result) => {
                var bounds = result.districtList[0].boundaries;
                var mask = []
                for (var i = 0; i < bounds.length; i += 1) {
                    mask.push([bounds[i]])
                }
                var map = new AMap.Map('mapBox', {
                    mask: mask,
                    center: option.value,
                    disableSocket: true,
                    viewMode: '3D',
                    showLabel: true,
                    labelzIndex: 130,
                    pitch: 40,
                    zoom: parseInt(option.zoom),
                    layers: [
                        new AMap.TileLayer(),
                        new AMap.TileLayer.Satellite()
                    ]
                });
                var maskerIn = new AMap.Marker({
                    position: [116.501415, 39.926055],
                    map: map
                })
                var maskerOut = new AMap.Marker({//区域外的不会显示
                    position: [117.001415, 39.926055],
                    map: map
                })
                //添加高度面
                var object3Dlayer = new AMap.Object3DLayer({ zIndex: 1 });
                map.add(object3Dlayer)
                var height = -20000;
                var color = '#00c4fd';//rgba //#2e453f
                var wall = new AMap.Object3D.Wall({
                    path: bounds,
                    height: height,
                    color: color
                });
                wall.transparent = true
                object3Dlayer.add(wall)
                //添加描边
                for (var i = 0; i < bounds.length; i += 1) {
                    new AMap.Polyline({
                        path: bounds[i],
                        strokeColor: '#99ffff',
                        strokeWeight: 4,
                        map: map
                    })
                }
                this.map = map;
            });
        },
        // 给地图标点 (企业标点)
        markMap(data, map) {
            for (let i = 0; i < data.length; i++) {
                let marker = null;

                if (data[i].longitude && data[i].latitude) {
                    // 创建高德地图坐标标志位置
                    let marker = this.initMarker(data[i]);
                    this.markerList.push(marker);
                    map.add(marker);
                }
            }

            // map.setFitView()
        },
        initMarker(data) {
            let marker = new AMap.Marker({
                // 图片标记
                position: [data.longitude, data.latitude], //位置
                title: data.name,
                extData:{
                  ...data
                }
            });
            // 自定义点标记内容
            var markerContent = document.createElement("div");

            // 点标记中的图标
            var markerImg = document.createElement("img");
            markerImg.className = "markerlnglat";
            // markerImg.src = "./image/biao.png";
            switch (data.status.toString()) {
                case "32": {
                    // 断电
                    markerImg.src = "./image/offline.png";
                    break;
                }
                case "1": {
                    // 正常
                    markerImg.src = "./image/biao.png";
                    break;
                }
                case "4": {
                    // 停机
                    markerImg.src = "./image/shut.png";
                    break;
                }
                case "16": {
                    // 停机
                    markerImg.src = "./image/warning.png";
                    break;
                }
                default: {
                    if ((data.status & 128) == 128) {
                        markerImg.src = "./image/warning.png";
                    } else {
                        markerImg.src = "./image/warn.png";
                    }
                }
            }
            //a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png
            markerContent.appendChild(markerImg);
            // 点标记中的文本
            var markerSpan = document.createElement("span");
            markerSpan.className = "marker";
            markerSpan.innerHTML = data.alias || data.name;
            markerContent.appendChild(markerSpan);

            marker.setContent(markerContent); //更新点标记内容
            marker.on("click", (e) => {
              const extData = marker.getExtData()
              console.log(extData)
              this.$router.push({
                path:"/chome/siteDetection",
                query:{
                  siteId:extData.id,
                  siteMn:extData.mn,
                  date:new Date().getTime()
                }
              });
                // 地图图标点击事件
                // let bindCompanies = this.$Local.getLocal("bindCompanies", "object"); // 获取用户企业信息
                // // 设置数组第一个企业信息标识为uuid(uuid取的是数组第一位)
                // bindCompanies.map((prop, index) => {
                //     // 冒泡排序换位置
                //     let temp = bindCompanies[0];
                //     if (prop.name == data.name) {
                //         bindCompanies[0] = bindCompanies[index];
                //         bindCompanies[index] = temp;
                //     }
                // });
                // // console.log(bindCompanies)
                // // bindCompanies[0] = data;
                // this.$Local.setLocal("bindCompanies", bindCompanies);
                // let roleList = this.$Local.getLocal("role", "object");
                // if (roleList.indexOf("siteDetection:page") != -1) {
                //     this.$router.push("chome");
                // } else {
                //     this.$router.push("chome/waste");
                // }
            }); //绑定click事件
            marker.zidingyi = data; // 绑定上企业信息
            return marker;
        },
        // 定位到原点
        goMapHome() {
            let parkInfo = this.$Local.getLocal("park", "object")[0];
            // var position = new AMap.LngLat(parkInfo.longitude, parkInfo.latitude);
            var position = new AMap.LngLat(119.164391,29.601392);
            this.map.setCenter(position);
        },
        // 全屏操作
        bigSmall() {
            // 全屏开关 true是点击放大 false是点击缩小
            let self = this;
            if (self.bigSreeen) {
                this.big();
            } else {
                this.small();
            }
            self.bigSreeen = !self.bigSreeen;
            self.bigWayFlag = true;
        },
        // 键盘事件导致的全屏或缩小执行
        bigWayChange() {
            if (this.$route.path != "/home") {
                window.removeEventListener("resize", this.bigWayChange);
                return false;
            }
            // 后来加的 当尺寸变化时 重置文字轮播容器高度(额外补充)
            //console.log(this.$refs.warnTableBox);
            if (this.$refs.warnTableBox)
                this.$refs.warnTableBox.style.height = "100%";

            let self = this;
            if (!self.bigSreeen && !self.bigWayFlag) {
                // true为全屏状态，并且是js触发
                self.bigSreeen = true;
            }
            self.bigWayFlag = false;
        },
        // 全屏
        big() {
            let element = document.documentElement;
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        },
        // 缩小
        small() {
            let element = document.documentElement;
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
        },
    }
}
</script>

<style lang="scss">
// .amap-marker-content {
//     // width: 2rem;
//     overflow: hidden;
// }
// .map-marker {
//     // width: 2rem;
//     // height: 4rem;
//     img {
//         width: 2rem;
//     }
//     .map-round-box {
//         width: 2rem;
//         height: 2rem;
//         background: rgba(249,83,123,0.25);
//         border-radius: 50%;
//         transform: rotateZ(45deg);
//     }
// }</style>

<style lang="scss" scoped>
.mapwithpoint {
    // background: #fff;
    width: 100%;
    height: 100%;
    position: relative;
    line-height: 1;


    .map_center {
        height: 100%;
        width: 100%;
        position: relative;

        .tooltip {
            position: absolute;
            bottom: 5em;
            left: 0;
            z-index: 99999;
            background: rgba($color: #000000, $alpha: 0.4);
            padding: 4px 0;

            .tip-list {
                display: flex;
                color: #fff;

                .tip-item {
                    margin: 0 10px;
                    font-size: 12px;

                    img {
                        width: 15px;
                        vertical-align: middle;
                        margin-right: 4px;
                    }
                }
            }
        }

        .border_top {
            width: 100%;
            height: 100%;
            // border: 0.125em solid;
            // border-image: -webkit-radial-gradient(#00657c, #00f8fa, #00657c) 20 20;
            // border-image: -moz-radial-gradient(#00657c, #00f8fa, #00657c) 20 20;
            // border-image: -o-radial-gradient(#00657c, #00f8fa, #00657c) 20 20;
            // border-image: radial-gradient(#00657c, #00f8fa, #00657c) 20 20;

            .map_box {
                width: 100%;
                height: 100%;
                background: transparent !important;
            }

            .map_footer {
                position: absolute;
                bottom: 0;
                left: 0;
                width: 100%;
                height: 4em;
                background-color: rgba($color: #000000, $alpha: 0.4);
                z-index: 999;

                // border: 0.125em solid;
                // border-image: -webkit-radial-gradient(#00657c, #00f8fa, #00657c) 20 20;
                // border-image: -moz-radial-gradient(#00657c, #00f8fa, #00657c) 20 20;
                // border-image: -o-radial-gradient(#00657c, #00f8fa, #00657c) 20 20;
                // border-image: radial-gradient(#00657c, #00f8fa, #00657c) 20 20;
                .icon_active {
                    color: #fff;
                    background-color: #008dfe;
                    border-radius: 50%;
                    width: 2em;
                    height: 2em;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;

                    i {
                        font-size: 1.5em;
                    }
                }

                .dingwei {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 2em;
                }

                .big_small {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    left: 5em;
                }

                .admin_main {
                    position: absolute;
                    width: 6em; // 96px
                    height: 2em;
                    background-color: #008dfe;
                    top: 50%;
                    right: 2em;
                    transform: translateY(-50%);
                    border-radius: 1em;
                    color: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                }

                .selectI {
                    position: absolute;
                    top: 1.1em;
                    right: 19em;
                    z-index: 997;

                    i {
                        font-size: 1.6em;
                        color: #00ecfb;
                        cursor: pointer;
                    }
                }

                .selectG {
                    position: absolute;
                    top: 1.1em;
                    right: 11em;
                    z-index: 997;

                    i {
                        font-size: 1.6em;
                        color: #00ecfb;
                        cursor: pointer;
                    }
                }
            }
        }
    }

    .signboard {
        position: absolute;
        left: 0;
        bottom: 0;
        background: url(../../../assets/newscreen/pointbg.png) no-repeat;
        background-size: 100%;
        width: 7.6875rem;
        height: 4.4375rem;
        display: flex;
        flex-wrap: wrap;

        .item {
            width: 50%;
            color: #fff;
            font-size: 0.75rem;
            display: flex;
            align-items: center;
            justify-content: center;

            .pp {
                display: inline-block;
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
                margin-right: 0.25rem;
                background: #fff;
            }
        }
    }

    .gongyitu {
        position: absolute;
        bottom: 0;
        left: 8.5rem;
        background: url(../../../assets/newscreen/map_bg_s.png) no-repeat;
        background-size: 100% auto;
        background-position: center bottom;
        padding-bottom: 1.75rem;
        cursor: pointer;

        .left-name {
            height: 2.5rem;
            line-height: 2.5rem;
            display: flex;
            align-items: center;
            background: rgba(6, 20, 55, 0.60);
            border: 0.8px solid rgba(63, 193, 255, 1);
            box-shadow: 0px 2px 3px 0px rgba(0, 231, 255, 0.43);
            color: #fff;
            padding: 0 0.5rem;
            color: #F5FAFF;
            letter-spacing: 0;
            text-shadow: 0 2px 4px #44D7B6;
            font-weight: 600;
        }
    }

    .container {
        width: 100%;
        height: 100%;

    }
}
</style>